import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44f42553"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questions-component" }
const _hoisted_2 = {
  key: 0,
  class: "card"
}
const _hoisted_3 = { class: "card-title mb-4 mt-2" }
const _hoisted_4 = ["id", "onChange"]
const _hoisted_5 = ["onUpdate:modelValue", "id", "onChange"]
const _hoisted_6 = ["for"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.questions.length && _ctx.actionQuestionSlide.Question)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(), _createElementBlock("div", {
              class: "card-body ps-4",
              key: _ctx.actionQuestionSlide.Question.value
            }, [
              _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.actionQuestionSlide.Question.value), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionQuestionSlide.answers, (answer, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: answer.Question.value
                }, [
                  (!_ctx.multipeAnswers)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        name: "`answers-${index}`",
                        type: "radio",
                        id: index,
                        onChange: ($event: any) => (_ctx.setAnswer(answer, index, $event))
                      }, null, 40, _hoisted_4))
                    : _createCommentVNode("", true),
                  (_ctx.multipeAnswers)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        name: "`answers-${index}`",
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.choosenAnswerReset[index]) = $event),
                        id: index,
                        onChange: ($event: any) => (_ctx.setAnswer(answer, index, $event))
                      }, null, 40, _hoisted_5)), [
                        [_vModelCheckbox, _ctx.choosenAnswerReset[index]]
                      ])
                    : _createCommentVNode("", true),
                  _createElementVNode("label", {
                    class: "ms-2",
                    for: index
                  }, _toDisplayString(answer.AnswerOption.value), 9, _hoisted_6)
                ]))
              }), 128)),
              _hoisted_7,
              (_ctx.showError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Diese Antwort ist leider falsch. Bitte probieren Sie es erneut. "))
                : _createCommentVNode("", true),
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              (_ctx.actionQuestionIndex > 0)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevQuestionSlide && _ctx.prevQuestionSlide(...args)), ["prevent"]))
                  }, "Zurück"))
                : _createCommentVNode("", true),
              _createElementVNode("a", {
                class: "float-end",
                href: "#",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextQuestionSlide && _ctx.nextQuestionSlide(...args)), ["prevent"]))
              }, "Weiter")
            ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}